(function EmailBuilders($, Adzuki)
{
	"use strict";

	$(document).ready(function onDocumentReady()
	{
		Adzuki.onload([
			'/EmailBuilders/add',
			'/EmailBuilders/edit',
			'/EmailBuilders/resend',
			'/EmailBuilders/addTemplate',
			'/EmailBuilders/editTemplate',
		], function onload()
		{
			// collapse/expands the email builder instructions
			$('.collapse-instructions').on('click', function onCollapseClick(e)
			{
				var $self = $(this);
				$self.toggleClass('plus');
				$self.toggleClass('minus');

				$('.eb-desc').collapse('toggle');
			});
		});

		Adzuki.onload([
			'/EmailBuilders/queue',
			'/EmailBuilders/sent',
			'/EmailBuilders/drafts',
			'/Reports/emailBuilderStatistics'
		], function onload() {
			$('.eb-view-email').on('click', function viewEmail(e) {
				var $modal_title     = $('.modal-title');
				var $modal_body      = $('.modal-body');
				var email_builder_id = $(this).data('id');

				e.preventDefault();

				Adzuki.Ajax.get('/EmailBuilders/view/' + email_builder_id)
				.then(function success(response)
				{
					$('#modalWindow').modal();

					$modal_title.html('View Email');
					$modal_body.html(response);
				});
			});
		});

		Adzuki.onload(['/EmailBuilders/customContent'], function onload()
		{
			$('.view-custom-content').on('click', function onViewCustomContentClick(e)
			{
				var $modal_title = $('.modal-title');
				var $modal_body  = $('.modal-body');
				var content_id   = $(this).data('content-id');
				var content_type = $(this).data('content-type');

				e.preventDefault();

				Adzuki.Ajax.get('/EmailBuilders/viewContent/' + content_type + '/' + content_id)
				.then(function success(response)
				{
					$('#modalWindow').modal();

					if (response.error) {
						$modal_body.html(response.error);
						return;
					}

					$modal_title.html(response.name);
					$modal_body.html('<img src="' + response.image + '" class="img-responsive img-thumbnail center-block">');
				});
			});
		});

		Adzuki.onload('/EmailBuilders/templates', function onload()
		{
			var $agent_templates     = $('#my-eb-templates');
			var $franchise_templates = $('#franchise-eb-templates');
			var $global_templates    = $('#global-eb-templates');
			var $filtered_templates  = $('#filtered-eb-templates');

			if ($filtered_templates.length > 0) {
				Adzuki.Ajax.get('/EmailBuilders/agentTemplates')
				.then(function agentTemplates(response) {
						$filtered_templates.html(response);
						_initViewTemplate();
					}
				);

				$filtered_templates.on('ajax-pagination.loaded', function _onFilteredTemplatesLoaded() {
					_initViewTemplate();
				});

				return;
			}

			// agent templates
			Adzuki.Ajax.get('/EmailBuilders/agentTemplates')
				.then(function agentTemplates(response) {
					$agent_templates.html(response);
					_initViewTemplate();
				}
			);

			$agent_templates.on('ajax-pagination.loaded', function _onAgentTemplatesLoaded() {
				_initViewTemplate();
			});

			// franchise shared templates
			Adzuki.Ajax.get('/EmailBuilders/franchiseTemplates')
				.then(function franchiseTemplates(response) {
					$franchise_templates.html(response);
					_initViewTemplate();
				}
			);

			$franchise_templates.on('ajax-pagination.loaded', function _onFranchiseTemplatesLoaded() {
				_initViewTemplate();
			});

			// global templates
			Adzuki.Ajax.get('/EmailBuilders/globalTemplates')
				.then(function globalTemplates(response) {
					$global_templates.html(response);
					_initViewTemplate();
				}
			);

			$global_templates.on('ajax-pagination.loaded', function _onGlobalTemplatesLoaded() {
				_initViewTemplate();
			});
		});
	});

	function _initViewTemplate()
	{
		$('.eb-view-email-template').off().on('click', function onViewEmailTemplate(e)
		{
			var $modal_title = $('.modal-title');
			var $modal_body  = $('.modal-body');
			var template_id  = $(this).data('template-id');

			e.preventDefault();

			Adzuki.Ajax.get('/EmailBuilders/viewTemplate/' + template_id)
			.then(function success(response)
			{
				$('#modalWindow').modal();

				$modal_title.html('View Template');
				$modal_body.html(response);
			});
		});
	}
}(jQuery, window.Adzuki || {}));
